import React, { useState, useEffect } from "react"
import Container from "@material-ui/core/Container"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import Fab from "@material-ui/core/Fab"
import Backdrop from "@material-ui/core/Backdrop"
import CheckIcon from "@material-ui/icons/Check"
import CircularProgress from "@material-ui/core/CircularProgress"
import Cabecalho from "../Cabecalho"
import * as Sentry from "@sentry/react"
import { Row, Col } from "react-bootstrap"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import Paper from "@material-ui/core/Paper"
import Button from "@material-ui/core/Button"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"
import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"

import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

import Grid from "@material-ui/core/Grid"

const useStyles = makeStyles(theme => ({}))

export default function DialogFiltro(props) {
    const { filtroAberto, setFiltroAberto } = props

    const { open } = filtroAberto

    const handleClose = () => {
        setFiltroAberto({
            tipo: "",
            valor: "",
            open: false,
        })
    }
    const handleFilter = e => {
        setFiltroAberto({
            ...filtroAberto,
            valor: document.getElementById("valorFiltro").value,
            open: false,
        })
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Filtrar por {filtroAberto.tipo.toUpperCase()}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Utilize o campo abaixo para filtrar por <b>{filtroAberto.tipo.toUpperCase()}</b>{" "}
                    e depois clique em filtrar.
                </DialogContentText>

                <TextField
                    label={`Inisira o ${filtroAberto.tipo}`}
                    fullWidth
                    id="valorFiltro"
                    variant={"outlined"}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="default">
                    Voltar
                </Button>
                <Button onClick={handleFilter} color="primary">
                    Filtrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
